<footer class="footer" id="contact">
    <div class="contact-us-part">
        <!-- <h6 class="mb-4 offset-md-5 call-us-text">Call or WhatsApp us now</h6> -->
        <div class="col-12 contact-email-container">
          <h6 class="offset-md-5 contact-item phone-contact">
            <span class="ringing">
              <fa-icon class="contact-us-icon hand-cursor edit-icon" size="1x" [icon]="faPhoneSquare"></fa-icon> 
            </span>
            Need help? call 
            <a href="tel:+91-98340 49944">+91-98340 49944</a>
          </h6>
          <h6 class="offset-md-5 contact-item email-contact">
            <fa-icon class="contact-us-icon hand-cursor edit-icon" size="1x" [icon]="faEnvelope"></fa-icon> 
            Email us at
            <a href="mailto:rasahriday@gmail.com">
              rasahriday@gmail.com
            </a>
          </h6>
        </div>
    </div>
    <div class="footer-info">
        <div class="text copyright-info">
          <span>© 2023 Rasahriday</span>
        </div>
    </div>
  </footer>